export function setLoggedUser(obj){
    localStorage.setItem("loggedUser",JSON.stringify(obj));
}

export function setMembership(obj){
    localStorage.setItem("membership",JSON.stringify(obj));
}

export function setAuthToken(authToken){
    localStorage.setItem("authToken",authToken);
}

export function setLicense(license){
    localStorage.setItem("license",JSON.stringify(license));
}

export function setInstitution(institution){
    localStorage.setItem("institution",JSON.stringify(institution));
}
